import { createContext, JSX, useState } from 'react';
import useMount from '../../../common/hooks/useMount';
import { customerService } from '../services/customer';
import { IPlatformInformation } from './common';

export const PlatformInfoContext = createContext(
  {} as IPlatformInformation | null,
);

export function PlatformInfoProvider(props: { children: JSX.Element }) {
  const [platformInfo, setPlatformInfo] = useState<IPlatformInformation | null>(
    null,
  );

  useMount(abortController => {
    (async () => {
      const result = await customerService.getCustomerPlatformInformation({
        signal: abortController?.signal,
      });

      if (!result.hasErrors) {
        setPlatformInfo(result.data);
      }
    })();
  });

  return (
    <PlatformInfoContext.Provider value={platformInfo}>
      {props.children}
    </PlatformInfoContext.Provider>
  );
}
